/* src/app/shared/components/invoice-payments/invoice-payments.component.scss */
.invoice-payments {
  width: 100%;
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
  display: block;
  box-sizing: border-box;
}
.invoice-payments__header {
  flex-wrap: wrap;
  gap: 0.75rem 2rem;
  padding: 1rem;
  font-weight: 600;
}
.invoice-payments__id,
.invoice-payments__name {
  opacity: 0.9;
}
.invoice-payments__tab-body {
  display: block;
  padding: 0.5rem;
}
.invoice-payments__spinner {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem;
}
.spinner-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
}
/*# sourceMappingURL=invoice-payments.component.css.map */
